import { render, staticRenderFns } from "./AppNavigationCaption.vue?vue&type=template&id=ee57be7e&scoped=true&"
import script from "./AppNavigationCaption.vue?vue&type=script&lang=js&"
export * from "./AppNavigationCaption.vue?vue&type=script&lang=js&"
import style0 from "./AppNavigationCaption.vue?vue&type=style&index=0&id=ee57be7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee57be7e",
  null
  
)

/* custom blocks */
import block0 from "./AppNavigationCaption.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cookbook/cookbook/cookbook/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee57be7e')) {
      api.createRecord('ee57be7e', component.options)
    } else {
      api.reload('ee57be7e', component.options)
    }
    module.hot.accept("./AppNavigationCaption.vue?vue&type=template&id=ee57be7e&scoped=true&", function () {
      api.rerender('ee57be7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigationCaption.vue"
export default component.exports